const TedFileIcon = () => (
  <div>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6666 7.33594V11.3359C14.6666 14.0026 13.9999 14.6693 11.3333 14.6693H4.66659C1.99992 14.6693 1.33325 14.0026 1.33325 11.3359V4.66927C1.33325 2.0026 1.99992 1.33594 4.66659 1.33594H5.66659C6.66659 1.33594 6.88659 1.62927 7.26659 2.13594L8.26659 3.46927C8.51992 3.8026 8.66659 4.0026 9.33325 4.0026H11.3333C13.9999 4.0026 14.6666 4.66927 14.6666 7.33594Z"
        stroke="#4583EC"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  </div>
);
export default TedFileIcon;
